import { PriceType } from '@app/shared/types/common';
import {
  WithdrawalStatus,
  WithdrawalReviewStatus,
} from '@app/store/slices/withdrawal/withdrawalTypes';
import { FindUserBy } from '@app/shared/types/admin/common';

export interface AdminFindUserFilters {
  value: string;
  searchType: FindUserBy;
}

export interface AdminFindUserResponseProfile {
  fullName: string | null;
  avatar: string | null;
}

export interface AdminFindUserResponseFinance {
  tonBalance: string;
  cookieBalance: string;
  tonFrozenBalance: string;
}

export interface AdminFindUserResponseCurator {
  id: number;
  telegramUsername: string | null;
  telegramId: string | null;
  profile: {
    fullName: string | null;
  } | null;
}

export interface AdminFindUserResponse {
  id: number;
  telegramUsername: string | null;
  telegramId: string | null;
  profile: AdminFindUserResponseProfile | null;
  finance: AdminFindUserResponseFinance | null;
  curator: AdminFindUserResponseCurator | null;
}

export enum AdminBalanceAction {
  TOP_UP = 'top up',
  WRITE_OFF = 'write off',
}

export interface AdminUpdateUserBalancePayload {
  userId: number;
  balanceType: PriceType;
  action: AdminBalanceAction;
  amount: number;
}

export interface AdminWithdrawalsFilters {
  search?: string;
  searchType?: FindUserBy;
  status: WithdrawalStatus;
  page?: number;
  limit?: number;
}

export interface AdminWithdrawalUser {
  telegramUsername: string | null;
  telegramId: string | null;
}

export interface AdminWithdrawal {
  id: number;
  userId: number;
  reviewedBy: number | null;
  status: WithdrawalStatus;
  address: string;
  requestedAmount: string;
  fee: string;
  payoutAmount: string;
  createdAt: string; // ISO date string
  user: AdminWithdrawalUser | null;
}

export interface AdminWithdrawalsResponse {
  withdrawals: AdminWithdrawal[];
  totalPages: number;
}

export interface AdminWithdrawalByIdResponse {
  withdrawal: (AdminWithdrawal & { reviewer: AdminWithdrawalUser | null }) | null;
}

export interface AdminUpdateWithdrawalStatusPayload {
  id: number;
  status: WithdrawalReviewStatus;
}

export enum AdminTagType {
  USER = 'User',
  WITHDRAWAL = 'Withdrawal',
}
